import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IShippingAddress, IUpdateShippingAddress } from "types/address";
import FETCHER from "./_fetcher";

export const getUserAddress = async () => {
  try {
    const result = await FETCHER.get<IShippingAddress[]>(`/user/addresses`);
    return result.data;
  } catch (e) {
    console.log(e);
  }
};

export const useGetUserAddress = () => {
  const { data = [], isLoading } = useQuery({
    queryKey: ["getUserAddress"],
    queryFn: () => getUserAddress(),
  });

  return {
    userAddress: data,
    isLoading,
  };
};

export const addShippingAddress = async (data: IShippingAddress) => {
  const result = await FETCHER.post(`/user/address`, data);
  return result;
};

export const useAddShippingAddress = () => {
  const queryClient = useQueryClient();

  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: addShippingAddress,
    onSuccess: () => {
      // for refetch cart item
      queryClient.invalidateQueries({
        queryKey: ["getUserAddress"],
      });
    },
  });
  return {
    data: data,
    addShippingAddressAsync: mutateAsync,
    isPending,
  };
};

export const updateShippingAddress = async (data: IUpdateShippingAddress) => {
  const result = await FETCHER.patch(`/user/address/${data.id}`, data);
  return result;
};

export const useUpdateShippingAddress = () => {
  const queryClient = useQueryClient();

  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: updateShippingAddress,
    onSuccess: () => {
      // for refetch cart item
      queryClient.invalidateQueries({
        queryKey: ["getUserAddress"],
      });
    },
  });
  return {
    data: data,
    updateShippingAddressAsync: mutateAsync,
    isPending,
  };
};
